module.exports = __webpack_public_path__ + "static/kate-1e0f54d1e1db655ae157ec934d95599f.jpg";